import {
	IGameplayActivityTimer,
	IGameplayJobProgress,
	MainMenuTabs,
} from '~/shared';
import { IObservable } from '../../utils';

/** Подсказка по клавише для отображения в худе */
export interface IGameKeyHelp {
	/** Иконка действия */
	icon: string;
	/** Клавиша */
	key: string;
}

export interface IRealTime {
	/** Отформатированное время (например, 17:07) */
	time: string;
	/** День недели (например, "Четверг") */
	weekday: string;
	/** День недели кратко (например, "чт") */
	weekdayShort: string;
	/** Дата (например, 17 октября) */
	date: string;
	/** Дата кратко (например, 17 окт.) */
	dateShort: string;
	/** Месяц */
	month: string;
}

export interface IGameArea {
	primaryName: string;
	secondaryName: string;
}

export enum PromotionType {
	DonateX2 = 'donate_x2',
}

export interface IServerNewsPostShort {
	id: string;
	title: string;
	shortText: string;
	date: number;
}

export interface IServerNewsPost {
	id: string;
	title: string;
	text: string;
	date: number;
}

export interface IGameService {
	/** Возвращает название текущего сервера */
	getServerName(): IObservable<string>;

	/** Возвращает активную акцию или null, если ее нет */
	getActivePromotion(): IObservable<PromotionType | null>;

	/**
	 * Возвращает подписку на количество игроков онлайн
	 */
	getOnlinePlayers(): IObservable<number>;

	/**
	 * Возвращает подписку на таймер, связанный с геймплейной активностью игрока (null, если таймер не активен)
	 */
	getActivityTimer(): IObservable<IGameplayActivityTimer | null>;

	/**
	 * Сбрасывает таймер, связанный с геймплейной активностью игрока
	 */
	resetActivityTimer(): void;

	/**
	 * Возвращает подписку на геймплейный прогресс игрока в работе (null, если какая-либо работа неактивна)
	 */
	getJobProgress(): IObservable<IGameplayJobProgress | null>;

	/**
	 * Возвращает подписку на текущее время игры
	 */
	getGameTime(): IObservable<string>;

	/**
	 * Возвращает подписку на текущее реальное время
	 */
	getRealTime(): IObservable<IRealTime>;

	/**
	 * Возвращает подписку на название района, в котором находится игрок
	 */
	getArea(): IObservable<IGameArea>;

	/**
	 * Возвращает подписку на вкладку по умолчанию в главном меню
	 */
	getDefaultMainMenuTab(): IObservable<MainMenuTabs | null>;

	/**
	 * Закрывает главное меню
	 */
	closeMainMenu(): void;

	/**
	 * Получить новости сервера
	 */
	getServerNewsPosts(): IObservable<Omit<IServerNewsPostShort, 'text'>[]>;

	/**
	 * Загрузить полный текст новости по id
	 */
	getServerNewsPost(
		id: string,
	): Promise<Omit<IServerNewsPost, 'shortText'> | null>;

	/**
	 * Состояние отображения точки взаимодействия
	 */
	getInteractState(): IObservable<boolean>;

	/**
	 * Состояние нахождения игрока в зелёной зоне
	 */
	getIsInGreenZone(): IObservable<boolean>;
}
